<script lang="ts" setup>
    import { type TextMessage } from '../TextMessagesTypes';
    import TextMessageHeader from './Components/TextMessageHeader.vue';
    import TextMessageEventInfo from './Components/TextMessageEventInfo.vue';
    import TextMessageMeta from './Components/TextMessageMeta.vue';
    import TextMessageProgressBars from './Components/TextMessageProgressBars.vue';
    import { type Status as Tab } from '../TextMessagesTypes';

    const props = defineProps<{
        textMessage: TextMessage;
        currentTab?: Tab;
    }>();

    const emit = defineEmits<{
        clickedTextMessageId: [id: string];
    }>();

    const draftStatus = 10;
    const sentStatus = 3;

    const handleTextMessageClick = () => {
        emit('clickedTextMessageId', props.textMessage.SmsMessageId);
    };
</script>

<script lang="ts"></script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)">
        <TextMessageHeader :textMessage="textMessage" :isButton="true" @click="handleTextMessageClick" />

        <TextMessageEventInfo :textMessage="textMessage" />

        <TextMessageMeta :textMessage="textMessage" />
    </div>

    <TextMessageProgressBars :textMessage="textMessage" :currentTab="currentTab" />
</template>

<style></style>
